import { MutationTree } from "vuex";
import {
  IStandardOfferState,
  IStandardOfferDto,
  DeliveryMethod
} from "./types";

export namespace STANDARD_OFFER_MUTATIONS {
  export const TOGGLE_IS_LOADING = "toggleIsLoading";
  export const SET_NAME = "setName";
  export const SET_VALID_FROM_DATE = "setValidFrom";
  export const SET_MAXIMUM_AMOUNT = "setMaximumAmount";
  export const SET_MINIMUM_AMOUNT = "setMinimumAmount";
  export const SET_DISCOUNTS = "setDiscounts";
  export const SET_DELIVERY_METHOD = "setDeliveryMethod";

  export const SET_APPLICATION_TYPE = "setApplicationType";
  export const SET_CUSTOMER_TYPE = "setCustomerType";
  export const SET_CLASS_OF_BUYER = "setClassOfBuyer";
  export const SET_PRICING_PROFILE = "setPricingProfile";
  export const SET_REBATE_PROFILE = "setRebateProfile";
  export const SET_SALES_REPRESENTATIVE = "setSalesRepresentative";
  export const SET_COLLECTION_MANAGER = "setCollectionManager";

  export const SET_OFFERS_LIST = "setOffersList";
  export const SET_OFFER = "setOffer";

  export const SET_DATA_TABLE_PAGINATION = "setDataTablePagination";
}

export const mutations: MutationTree<IStandardOfferState> = {
  [STANDARD_OFFER_MUTATIONS.TOGGLE_IS_LOADING](
    state: IStandardOfferState,
    isLoading: boolean
  ): void {
    state.isLoading = isLoading;
  },
  [STANDARD_OFFER_MUTATIONS.SET_NAME](
    state: IStandardOfferState,
    name: string
  ): void {
    if (state.offer) {
      state.offer.name = name;
    }
  },
  [STANDARD_OFFER_MUTATIONS.SET_VALID_FROM_DATE](
    state: IStandardOfferState,
    value: Date
  ): void {
    if (state.offer) {
      state.offer.validFromDate = value;
    }
  },
  [STANDARD_OFFER_MUTATIONS.SET_MAXIMUM_AMOUNT](
    state: IStandardOfferState,
    value: number
  ): void {
    if (state.offer) {
      state.offer.maximumAmount = value;
    }
  },
  [STANDARD_OFFER_MUTATIONS.SET_MINIMUM_AMOUNT](
    state: IStandardOfferState,
    value: number
  ): void {
    if (state.offer) {
      state.offer.minimumAmount = value;
    }
  },
  [STANDARD_OFFER_MUTATIONS.SET_DISCOUNTS](
    state: IStandardOfferState,
    value: any
  ): void {
    if (state.offer) {
      state.offer.discounts = value;
    }
  },
  [STANDARD_OFFER_MUTATIONS.SET_APPLICATION_TYPE](
    state: IStandardOfferState,
    value: string
  ): void {
    if (state.offer) {
      state.offer.applicationType = value;
    }
  },
  [STANDARD_OFFER_MUTATIONS.SET_CUSTOMER_TYPE](
    state: IStandardOfferState,
    value: string
  ): void {
    if (state.offer) {
      state.offer.customerType = value;
    }
  },
  [STANDARD_OFFER_MUTATIONS.SET_CLASS_OF_BUYER](
    state: IStandardOfferState,
    value: string
  ): void {
    if (state.offer) {
      state.offer.classOfBuyer = value;
    }
  },
  [STANDARD_OFFER_MUTATIONS.SET_PRICING_PROFILE](
    state: IStandardOfferState,
    value: string
  ): void {
    if (state.offer) {
      state.offer.pricingProfile = value;
    }
  },
  [STANDARD_OFFER_MUTATIONS.SET_REBATE_PROFILE](
    state: IStandardOfferState,
    value: string[]
  ): void {
    if (state.offer) {
      state.offer.rebateProfile = value;
    }
  },
  [STANDARD_OFFER_MUTATIONS.SET_SALES_REPRESENTATIVE](
    state: IStandardOfferState,
    value: string
  ): void {
    if (state.offer) {
      state.offer.salesRepresentative = value;
    }
  },
  [STANDARD_OFFER_MUTATIONS.SET_COLLECTION_MANAGER](
    state: IStandardOfferState,
    value: string
  ): void {
    if (state.offer) {
      state.offer.collectionManager = value;
    }
  },
  [STANDARD_OFFER_MUTATIONS.SET_OFFERS_LIST](
    state: IStandardOfferState,
    data: []
  ): void {
    state.offersList = data;
  },
  [STANDARD_OFFER_MUTATIONS.SET_OFFER](
    state: IStandardOfferState,
    offer: IStandardOfferDto
  ): void {
    state.offer = offer;
  },
  [STANDARD_OFFER_MUTATIONS.SET_DELIVERY_METHOD](
    state: IStandardOfferState,
    deliveryMethod: DeliveryMethod
  ): void {
    state.offer.deliveryMethod = deliveryMethod;
  },
  [STANDARD_OFFER_MUTATIONS.SET_DATA_TABLE_PAGINATION](state, value) {
    state.dataTable.pagination = value;
  },
};
